const templates = {
  title: 'Predlošci',
  create: 'Kreiraj predložak',
  edit: 'Uredi predložak',
  duplicate: 'Dupliciraj',
  duplicateTemplate: 'Dupliciraj predložak',
  templateDuplicated: 'Predložak dupliciran',
  templateName: 'Naziv predloška',
  templateFile: 'Datoteka predloška',
  templateNamePlaceholder: 'SOAP bilješka, Prvi pregled',
  templateLanguage: 'Jezik predloška',
  sections: 'Odjeljci',
  addSection: 'Dodaj odjeljak',
  sectionTitle: 'Naslov odjeljka',
  sectionTitlePlaceholder: 'Subjektivno, Procjena, Plan',
  sectionInstructions: 'Upute za AI',
  sectionInstructionsPlaceholder:
    'Upute o tome što ovaj odjeljak treba sadržavati...',
  save: 'Spremi',
  templateCreated: 'Predložak kreiran',
  cancel: 'Odustani',
  noSections: 'Nema odjeljaka. Dodajte prvi odjeljak za početak.',
  noTemplates: 'Još nema predložaka',
  noTemplatesDescription: 'Kreirajte svoj prvi predložak za početak.',
  section_one: '{{count}} odjeljak',
  section_other: '{{count}} odjeljaka',
  publicTemplate: 'Javni predložak',
  publicTemplateDescription:
    'Učinite ovaj predložak vidljivim svim korisnicima',
  personalTemplates: 'Moji predlošci',
  publicTemplates: 'Javni predlošci',
  separator: ' • ',
  loading: 'Učitavanje...',
  templateUpdated: 'Predložak ažuriran',
  invalidTemplateId: 'Neispravan ID predloška',
  templateNotFound: 'Predložak nije pronađen',
  validation: {
    templateNameRequired: 'Naziv predloška je obavezan',
    languageRequired: 'Jezik predloška je obavezan',
    atLeastOneSectionRequired: 'Potreban je barem jedan odjeljak',
    onlyDocxFilesAllowed: 'Dozvoljene su samo DOCX datoteke',
    sectionTitleRequired: 'Naslov odjeljka je obavezan',
    sectionInstructionsRequired: 'Upute za odjeljak su obavezne',
    fileRequired: 'Datoteka je obavezna',
  },
  public: 'Javno',
  private: 'Privatno',
  collapse: 'Sažmi',
  expandAll: 'Proširi sve',
  collapseAll: 'Sažmi sve',
  deleteConfirmTitle: 'Obriši predložak',
  deleteConfirmDescription:
    'Jeste li sigurni da želite obrisati "{{name}}"? Ova radnja se ne može poništiti.',
  delete: 'Obriši',
};

export default templates;
